import { IntlShape } from 'react-intl';

/** Turns a two-letter country code into its name in the reader's language. */
export function formatCountryName(intl: IntlShape, code: string): string {
  if (code === '' || code === 'XX') {
    return intl.formatMessage({ id: 'app.sml.stats.country.unknown', defaultMessage: 'Unknown' });
  }
  try {
    return new Intl.DisplayNames([intl.locale], { type: 'region' }).of(code) ?? code;
  } catch {
    return code;
  }
}
